import "core-js/modules/es6.array.find";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import healthStatusMixin from '@/components/core/virtualDevice/healthStatusMixin';
import get from 'lodash/get';
export default {
  name: 'CoreVirtualDeviceHealthStatusColumn',
  mixins: [healthStatusMixin],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    computedErrors: function computedErrors() {
      return this.getWithDefaultForNull(this.item, 'health.errors', []).map(this.addIsIgnoredFlag);
    },
    computedWarnings: function computedWarnings() {
      return this.getWithDefaultForNull(this.item, 'health.warnings', []).map(this.addIsIgnoredFlag);
    },
    invalidHealthState: function invalidHealthState() {
      return [0, 1, 2, 3].includes(this.item.state) === true;
    }
  },
  methods: {
    getWithDefaultForNull: function getWithDefaultForNull(obj, path, defaultValue) {
      var result = get(obj, path, defaultValue);
      return result === null ? defaultValue : result;
    },
    addIsIgnoredFlag: function addIsIgnoredFlag(issue) {
      var healthConfig = this.getWithDefaultForNull(this.item, 'healthConfig', []);
      var correspondingConfig = healthConfig.find(function (config) {
        return config.identifier === issue.id;
      });

      if (correspondingConfig) {
        issue._isIgnored = correspondingConfig.isIgnored || false;
      }

      return issue;
    }
  }
};